import * as R from "ramda";
import { makeAction } from "async-action-creator";
import { notification } from "antd";

import i18n from "../../i18n";
import api from "../../utils/api";
import { createApiThunk } from "../../utils/thunk";

export const FETCH_COMPANY_PURCHASES = makeAction(
  "purchases/FETCH_COMPANY_PURCHASES"
);
export const FETCH_COMPANY_PURCHASES_LITE = makeAction(
  "purchases/FETCH_COMPANY_PURCHASES_LITE"
);
export const PURCHASE_TEST = makeAction("purchases/PURCHASE_TEST");

export const fetchCompanyPurchases = createApiThunk({
  action: FETCH_COMPANY_PURCHASES,
  request: (_, { company }) =>
    company.id ? api.purchases.fetch(company.id) : []
});

export const fetchCompanyPurchasesLite = createApiThunk({
  action: FETCH_COMPANY_PURCHASES_LITE,
  request: (_, { company }) =>
    company.id ? api.purchases.fetchLite(company.id) : []
});

export const purchaseTest = createApiThunk({
  action: PURCHASE_TEST,
  request: async (idTest, state) => {
    const idCompany = R.path(["company", "id"], state);
    const idOpportunity = R.path(["opportunity", "selected", "id"], state);
    const idCandidate = R.path(["candidates", "selected", "id"], state);

    const purchase = await api.purchases.purchaseTest(
      idCompany,
      idOpportunity,
      idCandidate,
      idTest
    );

    return purchase;
  },
  onResolved: () =>
    notification.success({
      message: i18n.t("global:good"),
      description: i18n.t("toasts:company.purchaseSuccesful")
    }),
  onRejected: () =>
    notification.error({
      message: i18n.t("global:error"),
      description: i18n.t("toasts:company.purchaseError")
    })
});
